import { DELETE } from "../APiHelper/API"


export const deleteMessageFromSelection = (message_id, onSuccess, onError) => {

    DELETE(`/api/v1/conversations/delete_message_for_selection/${message_id}`, onSuccess, onError)
}